<template>
  <v-bottom-navigation
      height="200px"
      base-color="#1A1C25"
      color="white"
      grow
  >
    <v-row no-gutters justify="space-between" align="center" class="mt-2 ml-6 mr-6">
      <slot name="button"></slot>
      <v-col cols="2" class="mt-0">
        <button
            @click="pushToHomePage"
            v-ripple.stop
            :ripple="false"
            size="small"
            class="text-none"
            style="border-radius: 12px"
            width="100%"
            elevation="0"
            color="#A2ACB0"
            variant="text"
        >
          <div>
            <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_553_47)">
                <path d="M8.40676 16.4343V11.5429C8.40676 11.1326 8.70055 10.8626 9.12992 10.8626H12.4519C12.8927 10.8626 13.1639 11.1326 13.1639 11.5429V16.4343H8.40676ZM2.90396 16.0348C2.90396 17.2657 3.68361 17.9892 4.99435 17.9892H16.5875C17.8983 17.9892 18.678 17.2657 18.678 16.0348V9.65327L11.3107 3.75765C10.9943 3.4985 10.5762 3.5093 10.2712 3.75765L2.90396 9.65327V16.0348ZM0.881355 9.31853C1.16384 9.31853 1.40113 9.16737 1.60452 9.0054L10.4972 1.86802C10.5876 1.79244 10.7006 1.76005 10.7909 1.76005C10.8813 1.76005 10.983 1.79244 11.0734 1.86802L19.9773 9.0054C20.1808 9.16737 20.4181 9.31853 20.7005 9.31853C21.2542 9.31853 21.5818 8.94061 21.5818 8.54109C21.5818 8.32514 21.4802 8.08758 21.2655 7.91481L11.9208 0.421115C11.5593 0.140372 11.1751 0 10.7909 0C10.4068 0 10.0113 0.140372 9.661 0.421115L0.316384 7.91481C0.101695 8.08758 0 8.32514 0 8.54109C0 8.94061 0.327683 9.31853 0.881355 9.31853ZM16.452 4.44871L18.8926 6.41391V2.50509C18.8926 2.09478 18.6102 1.83564 18.1808 1.83564H17.1638C16.7458 1.83564 16.452 2.09478 16.452 2.50509V4.44871Z" :fill="btn_1_color" fill-opacity="0.85"/>
              </g>
              <defs>
                <clipPath id="clip0_553_47">
                  <rect width="22" height="18" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </div>
          <b :style="{color: btn_1_color}" class="mt-1">Главная</b>
        </button>
      </v-col>
      <v-col cols="2" class="mt-0">
        <button
            @click="pushToCheckHistory"
            v-ripple.stop
            :ripple="false"
            size="small"
            class="text-none"
            style="border-radius: 12px"
            width="100%"
            elevation="0"
            color="#F31549"
        >
          <div>
            <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_558_102)">
                <path d="M0 9.89447V8.11791H8.35545V0.0123291H10.1868V8.11791H18.5295V9.89447H10.1868V18H8.35545V9.89447H0ZM3.24298 18H15.2866C17.4612 18 18.5295 16.9637 18.5295 14.8911V3.12131C18.5295 1.04866 17.4612 0.0123291 15.2866 0.0123291H3.24298C1.08099 0.0123291 0 1.04866 0 3.12131V14.8911C0 16.9637 1.08099 18 3.24298 18Z" :fill="btn_2_color" fill-opacity="0.85"/>
              </g>
              <defs>
                <clipPath id="clip0_558_102">
                  <rect width="19" height="18" fill="white"/>
                </clipPath>
              </defs>
            </svg>

          </div>
          <b :style="{color: btn_2_color}" class="mt-1">Каталог</b>
        </button>
      </v-col>
      <v-col cols="2" class="mt-0 mr-3">
        <button
            @click="pushToBalancePage"
            v-ripple.stop
            :ripple="false"
            size="small"
            class="text-none"
            style="border-radius: 12px"
            width="100%"
            elevation="0"
            color="#A2ACB0"
        >
          <div>
            <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_556_57)">
                <path d="M9.28183 18C9.49412 18 9.80075 17.8572 10.0131 17.7145C15.3085 14.3358 18.5637 10.386 18.5637 6.35295C18.5637 2.99803 16.2757 0.618652 13.3389 0.618652C11.4873 0.618652 10.1428 1.64179 9.28183 3.18838C8.43266 1.65368 7.07637 0.618652 5.22471 0.618652C2.28802 0.618652 0 2.99803 0 6.35295C0 10.386 3.25512 14.3358 8.5506 17.7145C8.76289 17.8572 9.08133 18 9.28183 18Z" :fill="btn_3_color" fill-opacity="0.85"/>
              </g>
              <defs>
                <clipPath id="clip0_556_57">
                  <rect width="19" height="18" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </div>
          <b :style="{color: btn_3_color}" class="mt-1">Избранное</b>
        </button>
      </v-col>
      <v-col cols="2" class="mt-0">
        <button
            @click="pushToSettingsPage"
            v-ripple.stop
            variant="flat"
            :ripple="false"
            size="small"
            class="text-none"
            style="border-radius: 12px"
            width="100%"
            elevation="0"
            color="#A2ACB0"
        >
          <div>
            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_556_84)">
                <path d="M1.7375 17.9873H14.7875C15.8875 17.9873 16.5375 17.4792 16.5375 16.6281C16.5375 14.0494 13.3626 10.4926 8.26253 10.4926C3.17501 10.4926 0 14.0494 0 16.6281C0 17.4792 0.650002 17.9873 1.7375 17.9873ZM8.26253 8.71418C10.3625 8.71418 12.2126 6.79604 12.2126 4.29357C12.2126 1.80381 10.3625 0 8.26253 0C6.17502 0 4.32502 1.85462 4.32502 4.31898C4.32502 6.79604 6.17502 8.71418 8.26253 8.71418Z" :fill="btn_4_color" fill-opacity="0.85"/>
              </g>
              <defs>
                <clipPath id="clip0_556_84">
                  <rect width="17" height="18" fill="white"/>
                </clipPath>
              </defs>
            </svg>


          </div>
          <b :style="{color: btn_4_color}" class="mt-1">Профиль</b>
        </button>
      </v-col>
      <v-col cols="12"></v-col>
      <v-sheet class="bg-transparent" :style="{height: navHeight}"></v-sheet>
    </v-row>
  </v-bottom-navigation>
</template>

<script>

import store from "../store";

export default {
  name: "BottomNavComponent",
  computed: {
    store() {
      return store
    }
  },
  data() {
    return {
      navHeight: `${30}px`,
    }
  },
  props: {
    lang: {
      default: "en",
      type: String
    },
    btn_1_color: {
      default: "#A2ACB0",
      type: String
    },
    btn_2_color: {
      default: "#A2ACB0",
      type: String
    },
    btn_3_color: {
      default: "#A2ACB0",
      type: String
    },
    btn_4_color: {
      default: "#A2ACB0",
      type: String
    },
  },
  mounted() {
    if (!this.isMobile()) {
      this.navHeight = `${10}px`
    }
  },
  methods: {
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    pushToHomePage() {
      this.$router.push({name: 'Home'});
    },
    pushToCheckHistory() {
      this.$router.push({name: 'CheckHistory'});
    },
    pushToSettingsPage() {
      this.$router.push({name: 'Wishlist'});
    },
    pushToBalancePage() {
      this.$router.push({name: 'Wishlist'});
    },
    pushToFriendsPage() {
      this.$router.push({name: 'Friends'});
    },
  }
}

</script>

<style scoped>
button {
  outline: none;
  box-shadow: none;
}
</style>